<template>
		<form class="adminProfile">
			
			
			<div class="form-div wrap-navigate d-block d-md-none">
				<div class="avatar">
					<image-input
						name="profile_image"
						:avatar="avatar"
						@imageSavedGetNewImage="getAvatarUser"
					>
					</image-input>
				</div>
			</div>
			<div class="form-div row">
				<b-col cols="12" md="6">
					<div class="form-group">
						<label>{{ $t('userProfile.firstName') }}</label>
						<div class="input-div">
							<b-form-input
								:placeholder="$t('userProfile.firstName')"
								v-model="userParams.first_name"
								:class="{
									'form-group--error': $v.userParams.first_name.$error
								}"
								class="input-search"
							></b-form-input>
						</div>
					</div>
				</b-col>
				<b-col cols="12" md="6">
					<div class="form-group">
						<label>{{ $t('userProfile.lastName') }}</label>
						<div class="input-div">
							<b-form-input
								:placeholder="$t('userProfile.lastName')"
								v-model="userParams.last_name"
								:class="{ 'form-group--error': $v.userParams.last_name.$error }"
								class="input-search"
							></b-form-input>
						</div>
					</div>
				</b-col>
			</div>
			<div class="form-div row">
				<b-col cols="12" md="6">
					<div class="form-group">
						<label>{{ $t('userProfile.email') }}</label>
						<div class="input-div">
							<b-form-input
								:placeholder="$t('userProfile.email')"
								v-model="userParams.email"
								:class="{ 'form-group--error': $v.userParams.email.$error }"
								class="input-search"
							></b-form-input>
						</div>
					</div>
				</b-col>
				<b-col cols="12" md="6">
					<div class="form-group">
						<label>{{ $t('userProfile.phoneNumber') }}</label>
						<div class="input-div">
							<b-form-input
								:placeholder="$t('userProfile.phoneNumber')"
								v-model="userParams.telephone"
								:class="{ 'form-group--error': $v.userParams.telephone.$error }"
								class="input-search"
								type="number"
							></b-form-input>
						</div>
					</div>
				</b-col>
			</div>
			<div class="form-div row">
				<b-col cols="12" md="6">
					<div class="wrap-chose form-group">
						<div class="title-tooltip-left">
							{{ $t('userProfile.gender') }}
						</div>
						<b-dropdown no-flip
							class="input-choose-condition mt-10"
							:class="{ 'form-group--select-error': $v.userParams.gender.$error }"
						>
							<template v-slot:button-content>
								<span>
									{{ genderOption[userParams.gender]?genderOption[userParams.gender]:$t('userProfile.gender')  }}
									<ChevronDownIcon />
								</span>
							</template>
							<b-dropdown-item
								v-for="(item, key) in genderOption"
								:key="key"
								@click="handleGenderItem(key)"
							>
								{{ item }}
							</b-dropdown-item>
						</b-dropdown>
					</div>
				</b-col>

				<b-col cols="12" md="6">
					<div class="form-group">
						<label>{{
							`${$t('days')} / ${$t('month')} / ${$t(
								'addListing.details.year'
							)} ${$t('birth')}`
						}}</label>
						<div class="input-div">
							<Datepicker
								class="input-search"
								v-model="userParams.birthday"
								:class="{ 'error-date-time': $v.userParams.birthday.$error }"
								:format="customFormatter"
								placeholder="dd/mm/yyyy"
							></Datepicker>
						</div>
					</div>
				</b-col>
			</div>
			<div class="form-div row">
				<b-col cols="12" md="6">
					<div class="form-group">
						<label>
							{{ $t('line') }}
						</label>
						<div class="input-div">
							<b-form-input
									:placeholder="$t('line')"
									v-model="userParams.line_id"
									class="input-search"
									type="text"
							></b-form-input>
						</div>
					</div>
				</b-col>
			</div>
			<!-- Get our promotion -->
			<div
				v-if="false"
				class="form-div row checkbox-div"
			>
				<b-col cols="12" md="12" lg="6">
					<div class="form-group">
						<label>{{ $t('userProfile.chooseGetOurPromotion') }}</label>
					</div>
				</b-col>
				<b-col cols="12" md="12" lg="6">
					<b-row>
						<b-col cols="6">
							<div class="form-group">
								<b-form-checkbox v-model="userParams.is_notify_email">{{
									$t('userProfile.email')
								}}</b-form-checkbox>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="form-group">
								<b-form-checkbox v-model="userParams.is_notify_phone">{{
									$t('userProfile.phone')
								}}</b-form-checkbox>
							</div>
						</b-col>
					</b-row>
				</b-col>
			</div>
			
			<div class="button-div row">
				<b-col cols="12" class="text-center">
					<b-button
						@click="completeProfile"
						id="saveProfile"
						class="btn-submit-search"
						>{{ $t('userProfile.save') }}</b-button
					>
				</b-col>
			</div>
		</form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
	required,
	minLength,
	sameAs,
	between,
	email
} from 'vuelidate/lib/validators';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

import imageInput from '@/components/newAvtarUploader';

// Icons
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';

export default {
	components: {
		Datepicker,
		ChevronDownIcon,
		imageInput,
	},

	data() {
		return {
			avatar: null,
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null,
			avatarNew: null,
			saving: false,
			saved: false,
			userParams: {
				id: '',
				first_name: '',
				last_name: '',
				email: '',
				telephone: '',
				is_notify_email: false,
				is_notify_phone: false,
				gender: null,
				birthday: '',
				line_id:null,
				redirect_uri: window.location.origin,
				lang: ''
			},
			genderOption: {
				male: this.$t('male'),
				female: this.$t('female'),
				other: this.$t('other')
			}
		};
	},
	validations: {
		userParams: {
			first_name: {
				required
			},
			last_name: {
				required
			},
			email: {
				required,
				email
			},
			telephone: {
				required
			},
			gender: {
				required
			},
			birthday: {
				required
			},
			
		}
	},
	mounted() {
		this.setInfoUser();
		this.getAvatarUser();
	},
	created() {
		// this.GET_DETAIL_USER(this.profileUser).then(res => 
	},
	methods: {
		...mapActions('UserManagerController', [
			'UPDATE_INFO_USER_ADMIN',
			'UPDATE_INFO_USER_NORMAL',
			'GET_DETAIL_USER'
		]),
		...mapActions('UserController', ['UPLOAD_AVARTA_USER']),
		setInfoUser() {
			this.userParams.id = this.profileUser.id;
			this.userParams.first_name = this.profileUser.first_name;
			this.userParams.last_name = this.profileUser.last_name;
			this.userParams.email = this.profileUser.email;
			this.userParams.telephone = this.profileUser.telephone;
			this.userParams.is_notify_email =
				this.profileUser && this.profileUser.is_notify_email ? true : false;
			this.userParams.is_notify_phone =
				this.profileUser && this.profileUser.is_notify_phone ? true : false;
			this.userParams.gender = this.profileUser.gender;
			this.userParams.birthday = this.profileUser.birthday;
			this.userParams.line_id  = this.profileUser.line_id ;
		},
		completeProfile() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			} else {
				let prms = { ...this.userParams };
				prms.lang = this.$i18n.locale;
				prms.birthday = this.getDetailTime(this.userParams.birthday);
				this.UPDATE_INFO_USER_NORMAL(prms)
					.then(result => {
						if (result.data.success) {
							this.$store.dispatch('UserController/USER_PROFILE');
							this.$bvToast.toast(this.$t('User information has been updated successfully'), {
								title: this.$t(`Success`),
								variant: 'primary',
								solid: true
							});
						}
					})
					.catch(error => {
						this.$bvToast.toast(
							this.$t('There are some errors Please try again later'),
							{
								title: `Error!`,
								variant: "danger",
								solid: true
							}
						);
					});
			}
		},
		uploadImage() {
			this.saving = true;
			setTimeout(() => this.savedAvatar(), 1000);
		},
		savedAvatar() {
			this.saving = false;
			this.saved = true;
		},
		getAvatarUser() {
			setTimeout(() => {
				if (localStorage && localStorage.getItem('user_profile')) {
					let avatar_url = JSON.parse(localStorage.getItem('user_profile'))
						.profile_image;
					if (avatar_url) {
						this.avatar = avatar_url;
						this.$forceUpdate();
					} else {
						this.avatar = '/images/avatar.png';
						this.$forceUpdate();
					}
				}
			}, 500);
		},
		customFormatter(date) {
			// return moment(date).locale("th").format('YYYY-MM-DD');
			return moment(date)
				.locale('th')
				.format('DD MM YYYY');
		},
		getDetailTime(date) {
			// var d = moment(date,'DD MM YYYY').locale("th");
			// // var d = new Date(date)
			var check = moment(date, 'YYYY/MM/DD').locale('th');

			var month = check.format('M');
			var day = check.format('D');
			var year = check.format('YYYY');
			let detail = {
				month: month,
				day: day,
				year: year
			};
			return detail;
		},
		handleGenderItem(item) {
			this.userParams.gender = item;
		}
	},
	watch: {
		userProfile: function(val) {
			
		},
		avatarNew: function(val) {
			
			this.UPLOAD_AVARTA_USER(val.formData).then(result => {
				this.$store.dispatch('UserController/USER_PROFILE');
			});
		}
	}
};
</script>

<style lang="scss">
@import 'profile.scss';
</style>
